import { createContext, type ReactNode } from 'react'
import type { ActivityExplore } from '@domain/models/activity-explore'
import type { InstagramReel } from '@domain/models/instagram-reel'
import type { HackSymptom } from '@domain/models/pd-hacks'
import type { PodcastEpisode } from '@domain/models/podcast'
import type { Webinar } from '@domain/models/webinar'

export interface SsrHomeData {
  latestActivities?: ActivityExplore[]
  latestWebinars?: Webinar[]
  upcomingWebinars?: Webinar[]
  latestHacks?: HackSymptom[]
  latestPodcasts?: PodcastEpisode[]
  latestInstagramReels?: InstagramReel[]
}

export interface SsrPageData {
  routeKind?: string
  home?: SsrHomeData
  newsList?: {
    activities: ActivityExplore[]
    hasMore: boolean
  }
  newsDetail?: {
    activity: ActivityExplore | null
  }
  webinarsLatest?: {
    webinars: Webinar[]
    hasMore: boolean
  }
  webinarsUpcoming?: {
    webinars: Webinar[]
  }
  webinarDetail?: {
    webinar: Webinar | null
  }
  hacksList?: {
    hacks: HackSymptom[]
  }
  hackDetail?: {
    hack: HackSymptom | null
  }
  podcastsList?: {
    episodes: PodcastEpisode[]
    hasMore: boolean
  }
  podcastDetail?: {
    episode: PodcastEpisode | null
  }
  instagramReelsList?: {
    reels: InstagramReel[]
    hasMore: boolean
  }
  instagramReelDetail?: {
    reel: InstagramReel | null
  }
}

declare global {
  interface Window {
    __PARKINSONS_INSIGHTS_SSR__?: SsrPageData
  }
}

export const SsrDataContext = createContext<SsrPageData | null>(null)

export function SsrDataProvider({
  value,
  children,
}: {
  value: SsrPageData | null
  children: ReactNode
}) {
  return (
    <SsrDataContext.Provider value={value}>
      {children}
    </SsrDataContext.Provider>
  )
}
